<template>
  <v-dialog
    v-model="showDialog"
    width="500"
  >
    <v-card v-if="data">
      <v-card-title class="text-h5 grey lighten-2">
        Facturation pour {{ data.fullName }} - Edition {{ edition }}
      </v-card-title>

      <v-card-text class="py-3">
        <v-tabs
          v-model="tab"
          centered
        >
          <v-tab>Status</v-tab>
          <v-tab>Facture</v-tab>

          <v-tab-item>
            <div class="my-6">
              <v-select
                v-model="hasPaid"
                :items="items"
                label="Etat de la facturation"
                outlined
              >
                <template v-slot:item="{ item }">
                  <div
                    class="d-flex align-center justify-space-between"
                    style="width: 100%"
                  >
                    <div>
                      {{ item.text }}
                    </div>
                    <bill-status-icon :status="item.value" />
                  </div>
                </template>
              </v-select>

              <v-select
                v-if="billAction === 'paid'"
                v-model="billPayment"
                :items="payments"
                label="Facture payée "
                outlined
              >
                <template v-slot:item="{ item }">
                  <div
                    class="d-flex align-center justify-space-between"
                    style="width: 100%"
                  >
                    <div>
                      {{ item.text }}
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="my-6">
              <v-select
                v-model="billAction"
                :items="actions"
                label="Générer une facture"
                outlined
              >
                <template v-slot:item="{ item }">
                  <div
                    class="d-flex align-center justify-space-between"
                    style="width: 100%"
                  >
                    <div>
                      {{ item.text }}
                    </div>
                  </div>
                </template>
              </v-select>
              <br>

              <v-select
                v-if="billAction === 'paid'"
                v-model="billPayment"
                :items="payments"
                label="Facture payée "
                outlined
              >
                <template v-slot:item="{ item }">
                  <div
                    class="d-flex align-center justify-space-between"
                    style="width: 100%"
                  >
                    <div>
                      {{ item.text }}
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </v-tab-item>
        </v-tabs>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn
          color="primary"
          text
          @click="showDialog = false"
        >
          Fermer
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="tab === 0"
          outlined
          color="success"
          :loading="isSaving"
          @click="update()"
        >
          Confirmer
        </v-btn>
        <v-btn
          v-if="tab === 1"
          outlined
          color="success"
          :disabled="!billAction || (billAction === 'paid' && !billPayment)"
          :loading="isSaving"
          @click="generate()"
        >
          Générer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { get } from 'vuex-pathify'

  import BillStatusIcon from './BillStatusIcon.vue'

  export default {
    components: { BillStatusIcon },
    props: {
      value: Boolean,
      data: Object,
    },
    data: () => ({
      tab: null,
      hasPaid: false,
      paymentMode: '',
      isSaving: false,
      paidStatus: [
        {
          text: 'A été payé',
          value: true,
        },
        {
          text: 'N\'a pas été payé',
          value: false,
        },
      ],
      payments: [
        {
          text: 'Par chèque',
          value: 'check',
        },
        {
          text: 'Par virement',
          value: 'transfer',
        },
      ],
    }),
    computed: {
      edition: get('artifex/config.edition.edition'),
      showDialog: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        },
      },
    },
    watch: {
      data (val) {
        if (val) {
          this.billStatus = this.data.billStatus
        }
      },
    },
    methods: {
      generate () {
        window.open(`/nubium/participant/generate/invoice/${this.data.id}?type=${this.billAction}&payment=${this.billPayment}`, '_blank')
      },
      update () {
        this.isSaving = true
        this.$lco.admin
          .getParticipantBillStatus({ billStatus: this.billStatus })
          .then(() => {
            this.data.billStatus = this.billStatus
            this.isSaving = false
            this.showDialog = false
          })
          .catch(err => {
            console.log(err)
            this.isSaving = false
          })
      },
    },
  }
</script>
